<template style="height: 100%;     background-color: rgba(11, 45, 61, 1);">
  <div class="content-body">
    <h2 style="color: rgba(255, 241, 112, 1)" v-if="!IsInit">
      {{ PaperInfo.PaperName }}
    </h2>
    <div v-if="IsInit && QuestionIndex < 0" class="question-ct">
      <div class="paper-guide-left">
        <img
          :src="PaperInfo.PaperCoverURL"
          style="height: 200px; width: 200px"
        />
      </div>
      <div class="paper-guide-right">
        <div style="width: 100%; font-size: 24px; margin: 10px 0px;">指导语</div>
        <div style="width: 100%; font-size: 18px; margin: 10px 0px;">
          {{ PaperInfo.PaperName }}
        </div>
        <div
          style="width: 100%; font-size: 14px"
          v-html="PaperInfo.Guide"
        ></div>
      </div>
    </div>
    <div v-else-if="IsInit" class="question-ct">
      <div class="test-tip">
        <div class="PaperName">{{ PaperInfo.PaperName }}</div>
        <el-progress
          class="test-progress"
          :text-inside="true"
          :stroke-width="26"
          :percentage="Precent"
          :status="Precent == 100 ? 'success' : null"
        ></el-progress>
        <div class="test-t-left">共{{ PaperInfo.QuestionList.length }}题</div>
        <div class="test-t-right"></div>
      </div>

      <div
        class="qst-name-pquestion"
        v-if="
          PaperInfo.QuestionList[QuestionIndex].PQuestionName != null &&
          PaperInfo.QuestionList[QuestionIndex].PQuestionName != ''
        "
        v-html="PaperInfo.QuestionList[QuestionIndex].PQuestionName"
      >
        {{ PaperInfo.QuestionList[QuestionIndex].PQuestionName }}
      </div>
      <div
        class="qst-name"
        v-html="PaperInfo.QuestionList[QuestionIndex].QuestionName"
      >
        {{ PaperInfo.QuestionList[QuestionIndex].QuestionName }}
      </div>
      <div
        v-if="
          PaperInfo.QuestionList[QuestionIndex].QuestionImgPath != null &&
          PaperInfo.QuestionList[QuestionIndex].QuestionImgPath != '' &&
          PaperInfo.QuestionList[QuestionIndex].QuestionImgPath.indexOf(
            '.mp4'
          ) > -1
        "
      >
        <video
          :src="PaperInfo.QuestionList[QuestionIndex].QuestionImgPath"
          controls="true"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="allow"
        />
      </div>
      <div
        v-else-if="
          PaperInfo.QuestionList[QuestionIndex].QuestionImgPath != null &&
          PaperInfo.QuestionList[QuestionIndex].QuestionImgPath != ''
        "
      >
        <img
          :src="PaperInfo.QuestionList[QuestionIndex].QuestionImgPath"
          alt="QuestionImgPath"
        />
      </div>
      <div class="qst-ans">
        <el-radio-group
          v-model="PaperInfo.QuestionList[QuestionIndex].SelectAnsID"
          v-if="PaperInfo.QuestionList[QuestionIndex].QuestionType === 1"
          @change="radio_change"
        >
          <div
            v-for="item in PaperInfo.QuestionList[QuestionIndex].AnswerList"
            :key="item.AnswerID"
          >
            <template>
              <el-radio :key="item.AnswerID" :label="item.AnswerID">
                {{ item.AnswerName }}
              </el-radio>
              <el-checkbox-group
                v-model="item.ChildSelectAns"
                v-if="item.AnsOptionType === 2"
                class="ans-child"
              >
                <el-checkbox
                  v-for="an in item.AnswerList"
                  v-model="an.AnswerChecked"
                  :label="an.AnswerID"
                  :key="an.AnswerID"
                  :disabled="
                    !item.AnswerChecked ||
                    (item.AnswerChecked &&
                      PaperInfo.QuestionList[QuestionIndex].SelectAnsID !=
                        item.AnswerID)
                  "
                >
                  {{ an.AnswerName }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
          </div>
        </el-radio-group>
        <el-checkbox-group
          v-model="PaperInfo.QuestionList[QuestionIndex].SelectAnsID"
          v-if="PaperInfo.QuestionList[QuestionIndex].QuestionType === 2"
        >
          <el-checkbox
            v-for="ant in PaperInfo.QuestionList[QuestionIndex].AnswerList"
            :label="ant.AnswerID"
            :key="ant.AnswerID"
          >
            {{ Qst.AnswerName }}
          </el-checkbox>
        </el-checkbox-group>
        <div v-if="PaperInfo.QuestionList[QuestionIndex].QuestionType === 3">
          <el-input
            v-model="
              PaperInfo.QuestionList[QuestionIndex].AnswerList[0].AnswerResult
            "
            placeholder="请输入内容"
            maxlength="25"
            class="input-text"
          ></el-input>
        </div>
        <div
          v-if="PaperInfo.QuestionList[QuestionIndex].QuestionType === 5"
        ></div>
        <div v-if="PaperInfo.QuestionList[QuestionIndex].QuestionType === 9">
          <el-time-picker
            v-model="
              PaperInfo.QuestionList[QuestionIndex].AnswerList[0].AnswerResult
            "
            placeholder="任意时间点"
            class="input-text"
            format="HH:mm"
            value-format="HH:mm"
            style="width: auto"
          ></el-time-picker>
        </div>
      </div>
    </div>
    <el-row class="segment"></el-row>
    <el-row v-if="IsInit">
      <el-button
        class="Btnstar"
        v-if="QuestionIndex < 0"
        type="primary"
        @click="StartPaperTest"
      >
        开始测试
      </el-button>
      <el-button
        class="bgimg"
        v-if="QuestionIndex >= 0 && !PaperInfo.IsSkip"
        :disabled="QuestionIndex == 0"
        type="primary"
        @click="Prev"
      >
        上一题
      </el-button>
      <el-button
        class="bgimg"
        v-if="QuestionIndex >= 0 && !PaperInfo.IsSkip"
        :disabled="QuestionIndex == PaperInfo.QuestionList.length - 1"
        type="primary"
        @click="Next(0)"
      >
        下一题
      </el-button>
      <el-input
        v-model="JumpPageIndex"
        v-if="QuestionIndex >= 0 && !PaperInfo.IsSkip"
        placeholder="题号"
        maxlength="3"
        class="page-index"
        @focus="SetJumpState(1)"
        @blur="SetJumpState(0)"
        @keyup.native="number"
      ></el-input>
      <el-button
        class="bgimg"
        v-if="QuestionIndex >= 0 && !PaperInfo.IsSkip"
        type="primary"
        @click="JumpPage"
      >
        立即跳转
      </el-button>
      <el-button
        class="bgimg"
        v-if="QuestionIndex >= 0"
        :disabled="QuestionIndex == 0 || IsTestOk"
        type="primary"
        @click="Submit(0)"
        v-loading.fullscreen.lock="IsTmpSave"
      >
        临时保存
      </el-button>
      <el-button
        class="submit"
        v-if="QuestionIndex >= 0"
        :disabled="!IsTestOk"
        type="primary"
        @click="Submit(1)"
      >
        提交
      </el-button>
    </el-row>
    <div v-if="!IsInit" class="data-load">
      <div class="data-load-tip">
        <img src="../../assets/loadingbar.gif" alt="load" />
        <div>拼命加载中...</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      IsTmpSave: false,
      IsInit: false,
      IsCanSelect: true,
      IsTestOk: false,
      IsRemind: true, //提醒用户是否提交测评结果
      Precent: 0,
      PaperID: "dc8e5eee-3de3-4e81-bcf5-f87e5358087e",
      SourceNo: "",
      IsSkip: false,
      QuestionIndex: -1,
      AnsID: "",
      TmpAnswers: "",
      JumpPageIndex: "",
      IsSetJumpIndex: false,
      PreNumber: -1, //当前题目的上一题题号
      PaperInfo: {},
    };
  },
  mounted: function () {
    this.PaperID = this.$route.query.PaperID;
    this.SourceNo = this.$route.query.PublishID;
    this.InitPaper();
    this.BindKeyUp();
  },
  methods: {
    BindKeyUp() {
      let _this = this;
      document.onkeyup = function (e) {
        let el = e || window.event || arguments.callee.caller.arguments[0];
        if (el) {
          if (!_this.IsSetJumpIndex && el.keyCode >= 49 && el.keyCode <= 57) {
            //数字  1-9
            _this.SetRadioChecked(el.keyCode - 48);
          } else if (
            !_this.IsSetJumpIndex &&
            el.keyCode >= 65 &&
            el.keyCode <= 90
          ) {
            //字母 A-Z
            _this.SetRadioChecked(el.keyCode - 64);
          } else if (
            !_this.IsSetJumpIndex &&
            el.keyCode >= 97 &&
            el.keyCode <= 105
          ) {
            //小键盘 1-9
            _this.SetRadioChecked(el.keyCode - 96);
          }
        }
      };
    },
    InitPaper() {
      let _this = this;
      this.$Http_Post("Paper/GetPaperInfo", {
        SourceNo: _this.SourceNo,
        PaperID: _this.PaperID,
        UserID: _this.Global.userID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.PaperInfo = res.Data;
          _this.IsInit = true;
          if (_this.PaperInfo.IsSubmit == 0) {
            this.$confirm("是否继续完成测试", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "info",
              showClose: false,
              closeOnClickModal: false,
            })
              .then(() => {
                _this.QuestionIndex = _this.PaperInfo.PaperTestProgress;
                this.PreNumber = _this.QuestionIndex - 1;
                this.PaperInfo.QuestionList[_this.QuestionIndex].StartTime =
                  this.Global.getCurrentTime();
                this.GetPrecent();
              })
              .catch(() => {
                //从头开始重新测试
                for (let i = 0; i < _this.PaperInfo.QuestionList.length; i++) {
                  _this.PaperInfo.QuestionList[i].SelectAnsID = "-1";
                  _this.PaperInfo.QuestionList[i].PreQuestionNumber = -1;
                  _this.PaperInfo.QuestionList[i].IsAnswer = 0;
                  _this.PaperInfo.QuestionList[i].StartTime = "";
                  _this.PaperInfo.QuestionList[i].EndTime = "";
                  for (
                    let j = 0;
                    j < _this.PaperInfo.QuestionList[i].AnswerList.length;
                    j++
                  ) {
                    _this.PaperInfo.QuestionList[i].AnswerList[j].AnswerResult =
                      "";
                    _this.PaperInfo.QuestionList[i].AnswerList[
                      j
                    ].AnswerChecked = false;
                    _this.PaperInfo.QuestionList[i].AnswerList[j].SelectAnsID =
                      "";
                    _this.PaperInfo.QuestionList[i].AnswerList[
                      j
                    ].ChildSelectAns = [];
                    if (
                      _this.PaperInfo.QuestionList[i].AnswerList[j].AnswerList
                        .length > 0
                    ) {
                      for (
                        let k = 0;
                        k <
                        _this.PaperInfo.QuestionList[i].AnswerList[j].AnswerList
                          .length;
                        k++
                      ) {
                        _this.PaperInfo.QuestionList[i].AnswerList[
                          j
                        ].AnswerList[k].AnswerChecked = false;
                        _this.PaperInfo.QuestionList[i].AnswerList[
                          j
                        ].AnswerList[k].AnswerResult = "";
                      }
                    }
                  }
                }
              });
          }
        } else {
          this.$message({
            type: "error",
            message: Message,
          });
        }
      });
    },

    SetJumpState(state) {
      if (state === 1) this.IsSetJumpIndex = true;
      else this.IsSetJumpIndex = false;
    },
    StartPaperTest() {
      if (this.QuestionIndex === -1) {
        this.PaperInfo.StartDateTime = this.Global.getCurrentTime();
        this.PaperInfo.QuestionList[0].StartTime = this.PaperInfo.StartDateTime;
      }
      this.QuestionIndex++;
    },
    SetRadioChecked(anCode) {
      if (
        this.QuestionIndex > -1 &&
        this.IsCanSelect &&
        this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 1 &&
        anCode <=
          this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList.length
      ) {
        this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID =
          this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
            anCode - 1
          ].AnswerID;
        this.radio_change();
      }
    },
    getCurrentAnswer() {
      let ansIndex = -1;
      if (
        ((this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 1 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 2) &&
          this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID !=
            "-1") ||
        ((this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 3 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 9) &&
          this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[0]
            .AnswerResult != "")
      ) {
        this.PaperInfo.QuestionList[this.QuestionIndex].AnswerChecked = true;
        this.PaperInfo.QuestionList[this.QuestionIndex].IsAnswer = 1;
        this.PaperInfo.QuestionList[this.QuestionIndex].PreQuestionNumber =
          this.PreNumber;
        for (
          let i = 0;
          i < this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList.length;
          i++
        ) {
          if (
            ((this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType ===
              1 ||
              this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType ===
                2) &&
              this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[i]
                .AnswerID ==
                this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID) ||
            ((this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType ===
              3 ||
              this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType ===
                9) &&
              this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[0]
                .AnswerResult != "")
          ) {
            this.PaperInfo.QuestionList[this.QuestionIndex].EndTime =
              this.Global.getCurrentTime();
            this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
              i
            ].AnswerChecked = true;
            if (
              this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 3
            )
              this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID =
                this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
                  i
                ].AnswerID;
            ansIndex = i;
            if (
              this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[i]
                .AnswerList.length > 0
            ) {
              for (
                let j = 0;
                j <
                this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[i]
                  .AnswerList.length;
                j++
              ) {
                if (
                  this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
                    i
                  ].ChildSelectAns.indexOf(
                    this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
                      i
                    ].AnswerList[j].AnswerID
                  ) > -1
                ) {
                  this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
                    i
                  ].AnswerList[j].AnswerChecked = true;
                  this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
                    i
                  ].AnswerList[j].PreQuestionNumber =
                    this.PaperInfo.QuestionList[
                      this.QuestionIndex
                    ].PreQuestionNumber;
                }
              }
            }
          } else if (
            this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[i]
              .SelectAnsID.length > 0
          ) {
            this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
              i
            ].AnswerChecked = false;
            this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
              i
            ].ChildSelectAns = [];
          } else {
            this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[
              i
            ].AnswerChecked = false;
          }
        }
      }
      this.GetPrecent();
      return ansIndex;
    },
    GetPrecent() {
      let okCount = 0;
      this.PaperInfo.QuestionList.forEach((item) => {
        if (item.IsAnswer === 1) {
          okCount++;
        }
      });
      if (this.PaperInfo.IsSkip) {
        okCount = this.QuestionIndex + 1;
      }
      if (okCount > 0) {
        this.Precent = parseFloat(
          (
            (okCount * 100.0) /
            (this.PaperInfo.QuestionList.length * 1.0)
          ).toFixed(2)
        );
        if (
          (!this.PaperInfo.IsMissQuestion &&
            okCount === this.PaperInfo.QuestionList.length) ||
          (this.PaperInfo.IsSkip &&
            this.QuestionIndex === this.PaperInfo.QuestionList.length - 1)
        ) {
          this.IsTestOk = true;
        } else if (this.PaperInfo.IsMissQuestion && okCount > 0) {
          this.IsTestOk = true;
        }
      }
    },
    radio_change() {
      if (this.IsCanSelect) {
        this.IsCanSelect = false;
        let anIndex = this.getCurrentAnswer();
        if (
          this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[anIndex]
            .AnswerList.length === 0
        ) {
          setTimeout(() => {
            this.Next(1);
          }, 100);
        } else {
          this.IsCanSelect = true;
        }
      }
    },
    Next(state) {
      //state用来表示用选择答案自动跳转还是点击下一题的时候进行的跳转
      if (
        state === 0 &&
        !this.PaperInfo.IsMissQuestion &&
        (((this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 1 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType === 2) &&
          this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID ===
            "-1") ||
          ((this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType ===
            3 ||
            this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType ===
              9) &&
            this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[0]
              .AnswerResult === ""))
      ) {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "当前题目未作答",
        });
      } else {
        if (
          this.QuestionIndex >= 0 &&
          this.QuestionIndex < this.PaperInfo.QuestionList.length - 1
        ) {
          this.getCurrentAnswer();
          this.PreNumber = this.QuestionIndex;
          if (this.PaperInfo.IsSkip) {
            let skipQuestionID = null;
            for (
              let i = 0;
              i <
              this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList.length;
              i++
            ) {
              if (
                this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[i]
                  .SkipToQuestionId != "" &&
                this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[i]
                  .AnswerID ==
                  this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID
              ) {
                skipQuestionID =
                  this.PaperInfo.QuestionList[this.QuestionIndex].AnswerList[i]
                    .SkipToQuestionID;
                break;
              }
            }
            if (skipQuestionID != null && skipQuestionID != "") {
              for (let j = 0; j < this.PaperInfo.QuestionList.length; j++) {
                if (
                  this.PaperInfo.QuestionList[j].QuestionID === skipQuestionID
                ) {
                  this.QuestionIndex = j;
                }
              }
            } else this.QuestionIndex++;
          } else this.QuestionIndex++;
          this.PaperInfo.QuestionList[this.QuestionIndex].StartTime =
            this.Global.getCurrentTime();
        }
        this.IsCanSelect = true;
        this.JumpPageIndex = "";
        if (
          this.IsTestOk &&
          (!this.PaperInfo.IsMissQuestion ||
            (this.PaperInfo.IsMissQuestion && this.Precent === 100.0)) &&
          (this.IsRemind ||
            this.QuestionIndex === this.PaperInfo.QuestionList.length - 1)
        ) {
          document.onkeyup = "";

          this.$confirm("当前测试已完成，是否提交?", "提示", {
            confirmButtonText: "提交",
            cancelButtonText: "取消",
            type: "info",
            showClose: false,
            closeOnClickModal: false,
          })
            .then(() => {
              this.Submit(1);
            })
            .catch(() => {
              this.IsRemind = false;
              this.$message({
                type: "info",
                message: "已取消",
              });

              this.BindKeyUp();
              document.onkeyup = "";
            });
        }
      }
    },
    Prev() {
      if (this.QuestionIndex > 0) {
        this.PreNumber = this.QuestionIndex;
        this.QuestionIndex--;
        this.PaperInfo.QuestionList[this.QuestionIndex].StartTime =
          this.Global.getCurrentTime();
        this.IsCanSelect = true;
      }
    },
    JumpPage() {
      if (this.JumpPageIndex === "") {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "请输入跳转题号",
        });
      } else if (
        !this.PaperInfo.IsMissQuestion &&
        (this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType == 1 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType == 2) &&
        this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID === "-1"
      ) {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "当前题目未作答",
        });
      } else if (
        !this.PaperInfo.IsMissQuestion &&
        (this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType == 3 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType == 4 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType == 6 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType == 9 ||
          this.PaperInfo.QuestionList[this.QuestionIndex].QuestionType == 10)
      ) {
        this.getCurrentAnswer();
        if (
          this.PaperInfo.QuestionList[this.QuestionIndex].SelectAnsID ===
            "-1" &&
          !this.PaperInfo.QuestionList[this.QuestionIndex].AnswerChecked
        ) {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "当前题目未作答",
          });
        } else if (
          !(
            this.JumpPageIndex > 0 &&
            this.JumpPageIndex <= this.PaperInfo.QuestionList.length
          )
        ) {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "超出范围",
          });
        } else if (
          this.PaperInfo.QuestionList[this.JumpPageIndex - 1].SelectAnsID ===
            "-1" &&
          !this.PaperInfo.QuestionList[this.JumpPageIndex - 1].AnswerChecked
        ) {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "禁止跳转到未作答的题目",
          });
        } else {
          this.SetJumpQuestion();
        }
      } else if (
        this.JumpPageIndex > 0 &&
        this.JumpPageIndex <= this.PaperInfo.QuestionList.length
      ) {
        if (!this.PaperInfo.IsMissQuestion) {
          if (
            this.JumpPageIndex > 1 &&
            this.PaperInfo.QuestionList[this.JumpPageIndex - 2].SelectAnsID ===
              "-1"
          ) {
            this.$message.closeAll();
            this.$message({
              type: "warning",
              message: "无法跳转到未作答的题",
            });
          } else {
            this.SetJumpQuestion();
          }
        } else {
          this.SetJumpQuestion();
        }
      } else {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "超出范围",
        });
      }
    },
    SetJumpQuestion() {
      this.QuestionIndex = this.JumpPageIndex - 1;
      this.JumpPageIndex = "";
      this.PaperInfo.QuestionList[this.QuestionIndex].StartTime =
        this.Global.getCurrentTime();
    },
    Submit(IsCommit) {
      this.IsTmpSave = true;
      this.getCurrentAnswer();
      this.PaperInfo.EndDateTime = this.Global.getCurrentTime();
      let result = {
        PaperResultID: this.PaperInfo.PaperResultID,
        SourceNo: this.SourceNo,
        SourceFlg: 1,
        PaperID: this.PaperInfo.PaperID,
        PaperTestProgress: this.IsTestOk ? 0 : this.QuestionIndex,
        UserID: this.Global.userID,
        StartDateTime: this.PaperInfo.StartDateTime,
        EndDateTime: this.PaperInfo.EndDateTime,
        TmpResult: "",
        IsSubmit: IsCommit,
        Creator: this.Global.userID,
      };
      let itemValue = "";
      this.PaperInfo.QuestionList.forEach((qitem) => {
        if (qitem.IsAnswer === 1) {
          qitem.AnswerList.forEach((aitem) => {
            if (aitem.AnswerChecked) {
              itemValue =
                ";" +
                qitem.QuestionID +
                "|" +
                aitem.AnswerID +
                "|" +
                qitem.StartTime +
                "|" +
                qitem.EndTime +
                "|" +
                aitem.AnswerResult +
                "|" +
                aitem.PAnswerID +
                "|" +
                qitem.PreQuestionNumber;
              if (aitem.ChildSelectAns.length > 0) {
                aitem.ChildSelectAns.forEach((an) => {
                  itemValue +=
                    ";" +
                    qitem.QuestionID +
                    "|" +
                    an +
                    "|" +
                    qitem.StartTime +
                    "|" +
                    qitem.EndTime +
                    "||" +
                    aitem.AnswerID +
                    "|" +
                    qitem.PreQuestionNumber;
                });
              }
            }
          });
          result.TmpResult += itemValue;
        }
      });

      this.$Http_Post("Paper/Submit", { data: result }).then((res) => {
        this.$message.closeAll();
        if (res.Code == 200 || res.Code == 0) {
          document.onkeyup = "";
          this.$message({
            type: "success",
            message: res.Message,
          });
          setTimeout(function () {
            window.history.go(-1);
          }, 500);
        } else {
          this.IsTmpSave = true;
          this.$message({
            type: "error",
            message: "提交失败",
          });
          this.BindKeyUp();
        }
      });
    },
    number() {
      let flag = new RegExp("^[1-9]([0-9])*$").test(this.JumpPageIndex);
      if (!flag) {
        this.$message.closeAll();
        this.$message({
          showClose: true,
          message: "请输入正整数",
          type: "warning",
        });
        this.JumpPageIndex = this.JumpPageIndex.replace(/[^0-9]/g, "");
      }
    },
  },
};
</script>
<style>
.content-body {
  /* border: 1px solid #e4e7ed;
  background-color: #f6fafb; */
  height: calc(100% - 45px);
  padding: 20px;
  border-radius: 5px;
}
.content-body .data-load {
  width: 100%;
  height: 100%;
  position: relative;
}
.content-body .data-load-tip {
  width: 214px;
  height: 80px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  line-height: 30px;
  color: cornflowerblue;
}
.content-body h2 {
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.content-body .question-ct {
  height: calc(100% - 110px);
  overflow: auto;
}
.content-body .paper-guide {
  width: 50%;
  font-size: 18px;
  line-height: 30px;
  text-align: left;
  margin: 0 auto;
}
.content-body .test-tip {
  width: 60%;
  margin: 0px auto;
  padding: 2px 10%;
  font-size: 12px;
  overflow: hidden;
  margin-top: 5px;
}
.content-body .test-t-left {
  float: left;
}
.content-body .qst-name {
  background: rgba(7.139999999999998, 37.111, 51, 1);
  border: 1px solid rgba(30, 102, 135, 1);
  box-shadow: inset 3px 3px 2px rgb(0 0 0 / 50%),
    inset -2px -2px 2px rgb(34 58 69);
  border-radius: 4px;
  mix-blend-mode: normal;
  color: rgba(74, 216, 232, 1);
  font-size: 14px;
  height: 69px;
  text-align: center;
  width: 60%;
  margin: 0 auto;
  line-height: 69px;
}
.content-body .qst-name-pquestion {
  line-height: 30px;
  font-size: 20px;
  font-weight: bold;
  width: 60%;
  margin: 0 auto;
  text-align: left;
}
.content-body .qst-tip {
  color: rgba(28, 211, 220, 1);
  font-weight: bold;
}
.content-body .qst-ans {
  padding: 10px 50px;
  overflow: hidden;
}
.content-body .el-radio {
  display: block;
  white-space: normal;
  padding: 10px 0px;
  margin-right: 0px;
}
.content-body .el-row {
  text-align: center;
  margin-top: 10px;
}
.content-body .el-button:hover {
  background-color: #1359b8;
}
.content-body .el-radio__inner {
  display: none;
  background: rgba(10.000000000000002, 53.00000000000001, 84, 1);
  transform: scale(2);
}
.content-body .el-radio__label {
  margin-left: 5px;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 25px;
  vertical-align: middle;
  display: inline-block;
}
.content-body .page-index {
  background: linear-gradient(
    180deg,
    rgba(8, 47, 64, 1) 0%,
    rgba(8, 28, 48, 1) 100%
  );

  border-radius: 2px;
  mix-blend-mode: normal;
  display: inline;
  width: 100px !important;
  padding: 0px 10px;
}
.content-body .el-input__inner {
  width: 100px;
}
.content-body .el-radio-group {
  text-align: left;
  width: 100%;
}
.content-body .ans-child {
  margin-left: 50px;
}
.content-body .ans-child .el-checkbox {
  display: block;
  white-space: normal;
  padding: 6px 0px;
}
.content-body .ans-child .el-checkbox .el-checkbox__inner {
  transform: scale(1.5);
}
.content-body .ans-child .el-checkbox .el-checkbox__label {
  margin-left: 5px;
  font-size: 16px;
}
.content-body .content-body {
  border: 1px solid #e4e7ed;
  background-color: #f6fafb;
  height: calc(100% - 45px);
  padding: 20px;
  border-radius: 5px;
}
.content-body .data-load {
  width: 100%;
  height: 100%;
  position: relative;
}
.content-body .data-load-tip {
  width: 214px;
  height: 80px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  line-height: 30px;
  color: cornflowerblue;
}
.content-body h2 {
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.content-body .paper-guide {
  width: 50%;
  text-align: left;
  margin: 0 auto;
}
.content-body .test-progress {
  width: 50%;
  margin: 0px auto;
}
.content-body .el-progress-bar__inner {
  height: 15px;
}
.content-body .test-tip {
  padding: 2px 10%;
  font-size: 12px;
  overflow: hidden;
  margin-top: 5px;
}
.content-body .test-t-left {
  color: rgba(28, 211, 220, 1);
  float: left;
}
.content-body .qst-tip {
  color: rgba(28, 211, 220, 1);
  font-weight: bold;
}
.content-body .qst-ans {
  width: 60%;
  margin: 0px auto;
  padding: 10px 50px;
}
.content-body .el-radio {
  color: rgba(0, 230, 255, 1);
  font-size: 14px;
  display: block;
  white-space: normal;
  padding: 10px 0px;
  margin-right: 0px;
  background: rgba(10.097999999999999, 53.295, 84.15, 1);
  border: 1px solid rgba(30, 102, 135, 1);
  box-shadow: inset 3px 3px 2px rgba(0, 0, 0, 0.5),
    inset -2px -2px 2px rgba(34, 58, 69, 1);
  border-radius: 4px;
  mix-blend-mode: normal;
  margin-top: 10px;
  margin-bottom: 10px;
}
.content-body .el-row {
  text-align: center;
  margin-top: 10px;
}
.content-body .el-button:hover {
  background-color: #1359b8;
}
.content-body .el-radio__inner {
  transform: scale(2);
  margin-left: 20px;
}
.content-body .el-radio__label {
  margin-left: 5px;
  font-size: 16px;
}

.content-body .el-input__inner {
  width: 100px;
}
.content-body .el-radio-group {
  text-align: left;
  float: left;
}
.content-body .ans-child {
  margin-left: 50px;
}
.content-body .ans-child .el-checkbox {
  display: block;
  white-space: normal;
  padding: 6px 0px;
}
.content-body .ans-child .el-checkbox .el-checkbox__inner {
  transform: scale(1.5);
}
.content-body .ans-child .el-checkbox .el-checkbox__label {
  margin-left: 5px;
  font-size: 16px;
}

.content-body .el-progress.is-success .el-progress-bar__inner {
  background: rgba(28, 211, 220, 1);
}
.content-body .question-ct .qst-ans .el-input {
  width: 40%;
}
.content-body .question-ct .qst-ans .input-text input {
  width: 100%;
}
.content-body .Btnstar {
  width: 145px;
  height: 46px;
  background-image: url("../../assets/img/client/btn_test_play_selected.png");
  background-position-y: -10px;
  background-position-x: -10px;
  background-repeat: no-repeat;

  border-color: #409eff;
  background-size: 115%;
}
.content-body .segment {
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(11, 45, 61, 1) 0%,
    rgba(204, 169, 53, 1) 49.1%,
    rgba(11, 45, 61, 1) 100%
  );
}
.content-body .el-progress-bar__inner {
  background: rgba(28, 211, 220, 1);
}
.content-body .el-progress-bar__outer {
  height: 15px !important;
  background: rgba(10.000000000000002, 53.00000000000001, 84, 1);
}

.content-body .question {
  background: rgba(7.139999999999998, 37.111, 51, 1);
  border: 1px solid rgba(30, 102, 135, 1);
  box-shadow: inset 3px 3px 2px rgba(0, 0, 0, 0.5),
    inset -2px -2px 2px rgba(34, 58, 69, 1);
  border-radius: 4px;
  mix-blend-mode: normal;
}

.content-body .bgimg {
  background-image: url("../../assets/img/client/btn_rugular_bg.png");
  background-position-x: -14px;
  background-position-y: -10px;
  /* background: repeat; */
  background-size: 130%;
  color: rgba(0, 230, 255, 1);
  background-repeat: no-repeat;
}
.content-body .submit {
  background-image: url("../../assets/img/client/btn_test_play_selected.png");
  background-position-x: -14px;
  background-position-y: -7px;
  /* background: repeat; */
  background-repeat: no-repeat;
}

.content-body .PaperName {
  background-image: url("../../assets/img/client/img_content_bg.png");
  margin: 0px auto;
  background-repeat: no-repeat;
  height: 39px;
  background-size: 100% 100%;
  width: 50%;
  color: rgba(255, 241, 112, 1);
  font-size: 18px;
  line-height: 39px;
  text-align: center;
}

.paper-guide-left {
  width: 40%;
  float: left;
  color: rgba(255, 241, 112, 1);
  text-align: right;
}

.paper-guide-right {
  width: calc(40% - 40px);
  float: left;
  color: rgba(255, 241, 112, 1);
  padding: 10px 20px;
}
</style>
